<header class="row no-gutters top-panel align-items-center">
	<section class="col-12 col-md-5 text-16-bold title-container">
		<span class="title">
			<icon type="{{ topPanelConfig['icon']['icon'] }}" dcrContent [dcrKeys]="[topPanelConfig['icon']['key']]"></icon>
			<span class="icon-caption" dcrContent [dcrKeys]="[topPanelConfig['title']['key']]">{{ topPanelConfig['title']['label'] | uppercase }}</span>
		</span>
	</section>
	<section class="col-12 col-md-7 filter-container text-14">
		<span class="filter-wrapper" *ngIf="showSortingPanel['on']">
			<label dcrContent [dcrKeys]="[topPanelConfig['filterText']['key']]">{{ topPanelConfig['filterText']['label'] }}:</label>
			<ng-container *ngFor="let filter of filters; let i = index">
				<a
					class="filter sort-option text-14-bold"
					*ngIf="filter.show"
					[ngClass]="{ selected: filter.active }"
					[attr.data-link-event]="'Sort by: ' + filter.label"
					(click)="changeFilter(filter)"
					dcrContent
					[dcrKeys]="[topPanelConfig['filters'][filter.key]['key']]"
				>
					{{ filter.label }}
				</a>
				<span class="filter divider" *ngIf="showButtonSection['on'] && i < filters.length - 1"></span>
			</ng-container>
		</span>
		<a
			class="filter btn btn-dashboard-widget"
			dcrContent
			[dcrKeys]="[topPanelConfig['button']['key']]"
			*ngIf="showButtonSection['on']"
			[href]="topPanelConfig['button']['href']"
		>
			{{ topPanelConfig['button']['label'] }}
		</a>
	</section>
</header>
